var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { Dependencies } from '~/core/decorator';
import { namespace } from 'vuex-class';
import { UserService } from '~/services/management-service/user.service';
import { Emit, Prop } from 'vue-property-decorator';
var systemManageModule = namespace('system-manage');
var BatchCollectorLevel = /** @class */ (function (_super) {
    __extends(BatchCollectorLevel, _super);
    function BatchCollectorLevel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.batchParams = {
            userLevel: '',
            caseSwitch: '',
            userIds: [],
        };
        return _this;
    }
    BatchCollectorLevel.prototype.refreshList = function () { };
    BatchCollectorLevel.prototype.close = function () { };
    BatchCollectorLevel.prototype.refresh = function () {
        this.batchParams.userLevel = '';
    };
    BatchCollectorLevel.prototype.Commit = function () {
        var _this = this;
        this.batchParams.userIds = this.userList.map(function (v) { return v.id; });
        this.batchParams.caseSwitch = this.userList[0].caseSwitch;
        this.userService.batchUpdateUserLevel(this.batchParams).subscribe(function (data) {
            _this.$message.success('分配成功');
            _this.close();
            _this.refreshList();
        });
    };
    __decorate([
        Dependencies(UserService)
    ], BatchCollectorLevel.prototype, "userService", void 0);
    __decorate([
        Prop()
    ], BatchCollectorLevel.prototype, "userList", void 0);
    __decorate([
        Emit('refreshList')
    ], BatchCollectorLevel.prototype, "refreshList", null);
    __decorate([
        Emit('close')
    ], BatchCollectorLevel.prototype, "close", null);
    BatchCollectorLevel = __decorate([
        Component({
            components: {},
        })
    ], BatchCollectorLevel);
    return BatchCollectorLevel;
}(Vue));
export default BatchCollectorLevel;
